import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-empty-state',
  template: `
    <div class="text-center p-6 bg-surface rounded">
      <p class="text-muted">{{ message || title }}</p>
      <div class="mt-3"> <ng-content></ng-content> </div>
    </div>
  `
})
export class EmptyStateComponent {
  @Input() title = 'Nenhum resultado encontrado';
  @Input() message?: string;
}
